export default {"src":"/_next/static/media/boxedmeal.e339cb00.svg","height":16,"width":16};